import React, { useState, useEffect, useContext } from "react";
import PersistentDataGrid from "../../components/PersistentDataGrid";
import { useLocation } from "react-router-dom";
import {
  Grid,
  Typography,
  Divider,
  Tooltip,
  Button,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import styled from "styled-components";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import TermsIcon from "@mui/icons-material/School";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";

import {
  REFRESH_TOKEN_MUTATION,
  STAFF_MODULE_ACCESS_QUERY,
} from "../../graphQL/user_qry";
import {
  TENANT_ALL_USERS_QUERY,
  UPDATE_TENANT_USER_ISACTIVE,
  DELETE_TENANT_USER_MUTATION,
} from "../../graphQL/tenant_qry";

import { project_url } from "../../constants/Data";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    // width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
  tooltipStyle: {
    // paddingRight: 15,
    // cursor: "pointer",
    height: 24,
    weight: 24,
    paddingTop: 15,
  },
  srchButtonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "48px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    // marginBottom: 5,
    width: "180px",
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
}));

function UserContainer() {
  const [loadContent, setLoadContent] = useState(false);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
  const [alertMsg, setAlertMsg] = useState([]);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [alertChgUserIsActiveDlg, setAlertChgUserIsActiveDlg] = useState([]);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if (localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let clientId = 0;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");

  const [access, setAccess] = useState(true);
  const [addAccess, setAddAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [lockAccess, setLockAccess] = useState(false);
  const [termsAccess, setTermsAccess] = useState(false);
  const [groupsAccess, setGroupsAccess] = useState(false);



  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const classes = useStyles();
  const [tenantUsersList, setTenantUsersList] = useState([]);

  const [searchTenantUsersList, setSearchTenantUsersList] = useState([]);
  const [firstNameSrch, setFirstNameSrch] = useState("");
  const [lastNameSrch, setLastNameSrch] = useState("");

  const checkAccess = async () => {
    //check if staff has access to module
    const {
      loading: accessDataLoading,
      error: accessDataError,
      data: accessData,
    } = await checkStaffModuleAccess({
      variables: {
        tenantUserId: parseInt(tenantUserId),
        clientId: parseInt(clientId),
        moduleName: "Staff",
        modulepageName: "List",
      },
    });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split("|");
      if (commonActions.find(a => a === "Add")) setAddAccess(true);
      if (commonActions.find(a => a === "Edit")) setEditAccess(true);
      if (commonActions.find(a => a === "Delete")) setDeleteAccess(true);

      let additionalActions = accessData.staffModuleAccess.additionalActions.split("|");

      if (additionalActions.find(a => a === "Groups")) setGroupsAccess(true);
      if (additionalActions.find(a => a === "Activate/Deactivate")) setLockAccess(true);
      if (additionalActions.find(a => a === "Terms")) setTermsAccess(true);
    }

    if (
      accessDataError &&
      accessDataError.graphQLErrors &&
      accessDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };



  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const location = useLocation();

  useEffect(() => {
    
  if (location.state?.refresh) {
    setFirstNameSrch("");
    setLastNameSrch("");
    setSearchTenantUsersList(tenantUsersList);
  }
}, [location.state?.refresh]);

  const [reload, setReload] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type === "month").value +
      "/" +
      dayFormat.find(a => a.type === "day").value +
      "/" +
      dayFormat.find(a => a.type === "year").value;
    return newFormat;
  };

  const [getTenantUsersListQuery] = useManualQuery(TENANT_ALL_USERS_QUERY);
  const [updateTenantUserIsActive] = useMutation(UPDATE_TENANT_USER_ISACTIVE);
  const [deleteTenantUserMutation] = useManualQuery(DELETE_TENANT_USER_MUTATION);

  const tenantId = localStorage.getItem("tenantId")
    ? localStorage.getItem("tenantId")
    : 1;

  const getUserList = async () => {
    //remove storage if exist for client drop-down of group
    if (localStorage.getItem("selectedClientUuid"))
      localStorage.removeItem("selectedClientUuid");

    if (localStorage.getItem("selectedClientId"))
      localStorage.removeItem("selectedClientId");

    if (localStorage.getItem("selectedClientName"))
      localStorage.removeItem("selectedClientName");

    const {
      loading: loadingUserList,
      error: errorUserList,
      data: dataUserList,
    } = await getTenantUsersListQuery({
      variables: {
        tenantId: parseInt(tenantId),
      },
    });
    if (!loadingUserList && dataUserList && dataUserList.tenantAllUser) {
      console.log(dataUserList.tenantAllUser);
      setTenantUsersList(dataUserList.tenantAllUser);
      setSearchTenantUsersList(dataUserList.tenantAllUser);
    }
    if (errorUserList) {
      if (errorUserList.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
    }
  };

  useEffect(() => {
    if (firstLoad) {
      window.scrollTo(0, 0);
      setFirstLoad(false);
    }
    
    (async () => getUserList())();
  }, [reload]);

  const confirmChgUserIsActiveVal = (row, newVal) => {
    if (newVal) {
      setAlertChgUserIsActiveDlg({
        title: "Activate Staff",
        type: "activeDeactiveUser",
        msg: 'Are you sure you want to activate staff "' + row.name + '"?',
        butnVal: "Activate",
        userId: row.userId,
        status: newVal,
      });
    } else {
      setAlertChgUserIsActiveDlg({
        title: "Deactivate Staff",
        type: "activeDeactiveUser",
        msg: 'Are you sure you want to deactivate staff "' + row.name + '"?',
        butnVal: "Deactivate",
        userId: row.userId,
        status: newVal,
      });
    }
  };

  const getTermsData = (username, name) => {
    navigate(`${project_url}/staff/${username}/staff-terms`);
  };

  const updateLockStatus = async (userId, status) => {
    let {
      loading: loadMutation,
      error: errorMutation,
      data: dataMutation,
    } = await updateTenantUserIsActive({
      variables: {
        userId: parseInt(userId),
        isActive: status,
      },
    });

    if (!loadMutation && dataMutation.updateTenantUserIsactive.response) {
      setReload(!reload);
    } else {
      console.log(errorMutation);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 170,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 200,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => (
        <div
          style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
        >
          {rows.row.email}
        </div>
      ),
    },

    {
      field: "city",
      headerName: "City",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => (
        <div
          style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
        >
          {rows.row.city}
        </div>
      ),
    },
    {
      field: "state",
      headerName: "State",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => (
        <div
          style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
        >
          {rows.row.state}
        </div>
      ),
    },
    {
      field: "country",
      headerName: "Country",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => (
        <div
          style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
        >
          {rows.row.country}
        </div>
      ),
    },
    {
      field: "dateJoined",
      headerName: "Date Joined",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "dateActivated",
      headerName: "Date Activated",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },

    {
      field: "action",
      headerName: "Action",
      minWidth: 240,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var deleteCursor =
          rows.row.isTenantAdmin || !rows.row.deleteAccess ? "auto" : "pointer";

        var lockCursor =
          rows.row.isTenantAdmin || !rows.row.lockAccess ? "auto" : "pointer";

        var groupsCursor = rows.row.groupsAccess ? "pointer" : "auto";

        var termsCursor = rows.row.termsAccess ? "pointer" : "auto";

        return (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            {rows.row.lockStatus ? (
              <StyledTooltip
                title={
                  rows.row.isTenantAdmin
                    ? "Cannot deactivate Tenant Admin User"
                    : "Deactivate staff"
                }
              >
                <IconButton
                  className={classes.tooltipStyle}
                  style={{ cursor: lockCursor }}
                >
                  <LockOutlinedIcon
                    color={
                      rows.row.isTenantAdmin || !rows.row.lockAccess
                        ? "disabled"
                        : "action"
                    }
                    onClick={
                      rows.row.isTenantAdmin || !rows.row.lockAccess
                        ? undefined
                        : () => confirmChgUserIsActiveVal(rows.row, false)
                    }
                  />
                </IconButton>
              </StyledTooltip>
            ) : (
              <StyledTooltip title="Activate staff">
                <IconButton
                  className={classes.tooltipStyle}
                  style={{ cursor: lockCursor }}
                >
                  <LockOpenOutlinedIcon
                    color={rows.row.lockAccess ? "action" : "disabled"}
                    onClick={() =>
                      rows.row.lockAccess ? confirmChgUserIsActiveVal(rows.row, true) : ""
                    }
                  />
                </IconButton>
              </StyledTooltip>
            )}
            <StyledTooltip title="Staff Groups">
              <IconButton
                className={classes.tooltipStyle}
                style={{ cursor: groupsCursor }}
              >
                <ManageAccountsOutlinedIcon
                  color={rows.row.groupsAccess ? "action" : "disabled"}
                  onClick={() =>
                    rows.row.groupsAccess
                      ? navigate(`${project_url}/staff/` + rows.row.username + "/groups")
                      : ""
                  }
                />
              </IconButton>
            </StyledTooltip>
            <StyledTooltip title={(rows.row.termsAccess && !rows.row.deletable) ? "View Staff Terms": "Staff is not assigned to any client."}>
              <IconButton style={{ padding: 0, cursor: termsCursor }}>
                <TermsIcon
                  color={(rows.row.termsAccess && !rows.row.deletable) ? "action" : "disabled"}
                  onClick={() =>
                    rows.row.termsAccess && !rows.row.deletable
                      ? getTermsData(rows.row.username, rows.row.name)
                      : ""
                  }
                />
              </IconButton>
            </StyledTooltip>
            <StyledTooltip title="Edit staff">
              <IconButton className={classes.tooltipStyle} style={{ cursor: editCursor }}>
                <EditOutlinedIcon
                  color={rows.row.editAccess ? "action" : "disabled"}
                  onClick={() =>
                    rows.row.editAccess
                      ? navigate(`${project_url}/staff/` + rows.row.username)
                      : ""
                  }
                />
              </IconButton>
            </StyledTooltip>
            <StyledTooltip
              title={
                rows.row.isTenantAdmin
                  ? "Cannot delete Tenant Admin User"
                  : "Delete staff"
              }
            >
              <IconButton
                className={classes.tooltipStyle}
                style={{ cursor: deleteCursor }}
              >
                <DeleteOutlinedIcon
                  color={
                    rows.row.isTenantAdmin || !rows.row.deleteAccess
                      ? "disabled"
                      : "action"
                  }
                  onClick={
                    rows.row.isTenantAdmin || !rows.row.deleteAccess
                      ? undefined
                      : () => checkDeleteStatus(rows.row)
                  }
                />
              </IconButton>
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  var rows = searchTenantUsersList.map(tenantUser => ({
    id: tenantUser.tenantUserId,
    username: tenantUser.userId.username,
    userId: tenantUser.userId.id,
    name: tenantUser.userId.firstName + " " + tenantUser.userId.lastName,
    email: tenantUser.userId.email,
    phone: tenantUser.userId.phoneNo,
    city: tenantUser.userId.city,
    state: tenantUser.userId.state,
    country: tenantUser.userId.country,
    dateJoined: tenantUser.userId.dateJoined
      ? dayFormat(tenantUser.userId.dateJoined)
      : "",
    dateActivated: tenantUser.userId.profile.activationDate
      ? dayFormat(tenantUser.userId.profile.activationDate)
      : "",
    lockStatus: tenantUser.userId.isActive,
    deletable: tenantUser.userId.deletable,
    status: tenantUser.userId.isActive ? "Active" : "Inactive",
    isTenantAdmin: tenantUser.isTenantAdmin,

    editAccess: editAccess,
    deleteAccess: deleteAccess,
    groupsAccess: groupsAccess,
    lockAccess: lockAccess,
    termsAccess: termsAccess,
  }));

  const applySearch = e => {
    e.preventDefault();

    const result = tenantUsersList.filter(tenantUser => {
      const firstNameMatch =
        firstNameSrch === "" ||
        tenantUser.userId.firstName.toLowerCase().includes(firstNameSrch.toLowerCase());

      const lastNameMatch =
        lastNameSrch === "" ||
        tenantUser.userId.lastName.toLowerCase().includes(lastNameSrch.toLowerCase());

      return firstNameMatch && lastNameMatch;
    });

    setSearchTenantUsersList(result);
  };

  const onKeyPress = e => {
    if (e.key === "Enter") applySearch(e);
  };

  const checkDeleteStatus = row => {
    if (row.deletable)
      setAlertDeleteMsg({
        title: "Delete Staff",
        type: "deleteConfirmation",
        msg: 'Are you sure you want to delete staff "' + row.name + '"?',
        userId: row.userId,
      });
    else
      setAlertDeleteMsg({
        title: "Delete Staff",
        msg: "Staff cannot be deleted, because staff is found at least in one team of one client(s).",
      });
  };
  const deleteUser = async index => {
    const {
      loading: loadingDeleteUser,
      error: errorDeleteUser,
      data: dataDeleteUser,
    } = await deleteTenantUserMutation({
      variables: {
        userId: parseInt(index),
      },
    });
    if (errorDeleteUser && errorDeleteUser.graphQLErrors) {
      setAlertMsg({
        title: "Error",
        msg: errorDeleteUser.graphQLErrors[0].message,
      });
    } else if (!loadingDeleteUser && dataDeleteUser && dataDeleteUser.deleteTenantUser) {
      setReload(!reload);
    }
  };

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Staff List
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              disabled={!addAccess ? "disabled" : ""}
              onClick={() => (addAccess ? navigate(`${project_url}/staff/add`) : "")}
            >
              Add
            </Button>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }

  if (loadContent)
    if (access)
      return (
        <div className={classes.root}>
          <Header />
          <div className={classes.container}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 2,
              }}
            >
              <TextField
                className={classes.textFieldStyle}
                label="First Name"
                // margin="normal"
                type="text"
                variant="outlined"
                value={firstNameSrch}
                onChange={e => {
                  setFirstNameSrch(e.target.value);
                }}
                onKeyPress={onKeyPress}
              />

              <TextField
                className={classes.textFieldStyle}
                label="Last Name"
                // margin="normal"
                type="text"
                variant="outlined"
                value={lastNameSrch}
                onChange={e => {
                  setLastNameSrch(e.target.value);
                }}
                onKeyPress={onKeyPress}
              />

              <Button
                variant="contained"
                color="primary"
                className={classes.srchButtonStyle}
                onClick={applySearch}
              >
                Search
              </Button>
            </Box>
            <PersistentDataGrid
              persistenceKey="staff-list"
              className={classes.dataGridStyle}
              columns={columns}
              rows={rows}
              showCellRightBorder={true}
              // hideFooter={true}
              slots={{
                toolbar: DataGridTitle,
              }}
              getRowId={row => row.id}
              autoHeight={true}
              experimentalFeatures={{ newEditingApi: true }}
                sx={{
                  "& .MuiDataGrid-cell": {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                  },
                }}
              initialState={{
                pagination: { paginationModel: { pageSize: 10 } },
                //   sorting: {
                //     sortModel: [{ field: "dateUpdated", sort: "desc" }],
                //   },
              }}
              pageSizeOptions={[10, 25, 50]}
              getRowClassName={params => (params.row.isTenantAdmin ? "current-row" : "")}
            />
            <style>
                {`
              .current-row {
                background-color: rgba(203, 255, 139, 0.33) !important; /* Light green */
              }
            `}
              </style>
          </div>
          {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                setAlertDeleteMsg([]);
                deleteUser(alertDeleteMsg.userId);
              }}
            />
          )}
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
              }}
            />
          )}
          {alertChgUserIsActiveDlg.msg && (
            <AlertDialog
              title={alertChgUserIsActiveDlg.title}
              type={alertChgUserIsActiveDlg.type}
              contentMsg={alertChgUserIsActiveDlg.msg}
              closeDialog={() => setAlertChgUserIsActiveDlg([])}
              activeDeactiveUserFunc={() => {
                setAlertChgUserIsActiveDlg([]);
                updateLockStatus(
                  alertChgUserIsActiveDlg.userId,
                  alertChgUserIsActiveDlg.status,
                );
              }}
              activeDeactiveUserButn={alertChgUserIsActiveDlg.butnVal}
            />
          )}
        </div>
      );
    else
      return (
        <div className={classes.root}>
          <div className={classes.container}>
            <AlertDialog
              title="No Permission"
              contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.'
              closeDialog={() => {
                navigate(`${project_url}/tenant/dashboard`);
              }}
            />
          </div>
        </div>
      );
  else return;
}

export default UserContainer;
